export default __webpack_public_path__ + "2d36c424df87263de7d9fc31dcd45f83.png";